export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      screenConfigMsts: [
        {
          screenConfigMstId: 4,
          screenConfigMstUuid: "screenconfigmst004",
          screenConfigName: "hoam系ホーム画面",
          deviceTypeUuid: "device001",
          deviceTypeName: "Hoam",
          serviceTypeKbn: 2,
          serviceTypeName: "hoam系",
          screenOrientationKbn: 1,
          screenConifgStatus: 1,
          screenWidth: 1920,
          screenHeight: 1080
        },
        {
          screenConfigMstId: 3,
          screenConfigMstUuid: "screenconfigmst003",
          screenConfigName: "コミュニティサポート系ライブカメラ画面",
          deviceTypeUuid: "device002",
          deviceTypeName: "XXXXBOX",
          serviceTypeKbn: 1,
          serviceTypeName: "コミュニティサポート系",
          screenOrientationKbn: 0,
          screenConifgStatus: 1,
          screenWidth: 1280,
          screenHeight: 800
        },
        {
          screenConfigMstId: 2,
          screenConfigMstUuid: "screenconfigmst002",
          screenConfigName: "コミュニティサポート系お知らせ一覧画面",
          deviceTypeUuid: "device002",
          deviceTypeName: "XXXXBOX",
          serviceTypeKbn: 1,
          serviceTypeName: "コミュニティサポート系",
          screenOrientationKbn: 1,
          screenConifgStatus: 1,
          screenWidth: 1280,
          screenHeight: 800
        },
        {
          screenConfigMstId: 1,
          screenConfigMstUuid: "screenconfigmst001",
          screenConfigName: "コミュニティサポート系トップ画面",
          deviceTypeUuid: "device002",
          deviceTypeName: "XXXXBOX",
          serviceTypeKbn: 1,
          serviceTypeName: "コミュニティサポート系",
          screenOrientationKbn: 1,
          screenConifgStatus: 1,
          screenWidth: 1280,
          screenHeight: 800
        }
      ]
    }
  }
}